// extracted by mini-css-extract-plugin
export default {"tabContainer":"account_tabContainer__9WJcc"};